export const stepDown = (value: number, step: number, min = 0) => {
	const rounded = Math.floor(value / step) * step;
	return Math.max(min, rounded < value ? rounded : value - step);
};
